import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryTag = fp.get('inventory.tag');

export const getAll = createSelector(getInventoryTag, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getIsFetching = createSelector(
  getInventoryTag,
  fp.get('fetching')
);
export const getIsFetched = createSelector(getInventoryTag, fp.get('fetched'));
export const getFetchingError = createSelector(
  getInventoryTag,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(getInventoryTag, fp.get('saving'));

export const getIsSaved = createSelector(getInventoryTag, fp.get('saved'));

export const getSavingError = createSelector(
  getInventoryTag,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getInventoryTag,
  fp.get('deleting')
);
export const getIsDeleted = createSelector(getInventoryTag, fp.get('deleted'));
export const getDeletingError = createSelector(
  getInventoryTag,
  fp.get('deletingError')
);

export const getOrder = createSelector(getInventoryTag, fp.get('order'));
